module.exports = __webpack_public_path__ + "static/Company_graphic1-095eef29b4c9c2c7f9400cdf280b5e92.svg";